import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Compontents //
import TitleSection from "../../molecules/title-section";
import RequirementCard from "../../molecules/requirement-card/requirementCard";

// Styles
import "./requirementsSection.scss";

const RequirementsSection = (props: ReferenciaContenido) => {
    const { 
        tituloGeneral, 
        referenciaPlantillaContenido: refPlantilla
    } = props;

    return (
        <div className="o-requirements-section">
            <div className="o-requirements-section__title">
                <TitleSection
                    title={`${tituloGeneral}`}
                    type="h1"
                />
            </div>
            <div className="o-requirements-section__container">
                {refPlantilla.map((item, index) => (
                    <RequirementCard
                        key={index}
                        description={documentToReactComponents(
                            item.descripcion.json
                        )}
                        useCheckIcon={true}
                    />
                ))}
            </div>
        </div>
    );
};

export default RequirementsSection;
